var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSegmentEnergyInfrastructure({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M686 897C687 897 689 897 691 896C702 893 709 882 706 870L611 496L671 323H762C772 323 780 316 782 306C785 296 779 286 770 282L693 248L704 153C705 143 700 134 690 130C681 127 671 130 665 139L600 237H424L358 139C352 131 342 127 333 131C323 134 318 144 319 153L331 249L253 282C244 286 239 296 241 305C243 315 251 323 261 323L352 324L412 496L317 870C315 879 319 889 327 894C336 899 346 897 353 890L530 712C539 704 539 691 530 682C522 674 509 674 500 682L378 805L455 500C456 496 456 492 455 488L387 296C384 288 376 282 367 282H363C371 278 376 269 375 259L372 237L395 271C399 276 405 280 413 280H611C618 280 625 276 629 271L651 237L649 259C648 268 652 276 660 280H655C646 280 638 286 635 295L568 488C567 492 567 496 568 500L665 881C667 891 676 897 686 897Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSegmentEnergyInfrastructure);
export default __webpack_public_path__ + "static/media/segment_energy_infrastructure.7d6314e50429890f2dc383c731f03990.svg";
export { ForwardRef as ReactComponent };